import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserAnalysisService } from './shared/services/user-analysis.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  constructor(
    private translateService: TranslateService,
    private userAnalysisService: UserAnalysisService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('lang') || 'en');
  }

  ngOnInit(): void {
    this.userAnalysisService.logSessionEntry();
    this.userAnalysisService.startPresenceTracking();
  }

  ngOnDestroy(): void {
    this.userAnalysisService.stopPresenceTracking();
  }

  title = 'alignmaster';
}

